import React, { useContext, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import {
  ButtonLogout,
  ContentAvatar,
  DataUser,
  IconFE,
  TextButtonLogout,
  TextEditProfile,
  TitleDataUser,
} from "./styles";
import { Button, Container, Content, Header, TextField } from "../../components";
import { themes } from "../../design/colors";
import UserContext from "../../context/user";
import AsyncStorage from "@react-native-async-storage/async-storage";

function UpdateProfile() {
  const navigation = useNavigation();
  const { changePassword } = useContext(UserContext);

  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleResetPassword() {
    setLoading(true);
    const data = { password };
    try {
      await changePassword(data);
      setLoading(false);
      navigation.goBack();
    } catch (_) {
      console.log('recoveryPassword error screen');
      setLoading(false);
    }
  }

  return (
    <Container>
      <Header type="simple" title="Atualizar senha" />
      <Content>
        <TextField
          label="Nova senha"
          placeholder="Digite sua nova senha"
          value={password}
          secureTextEntry
          onChangeText={(text: string) => setPassword(text)}
        />
        <Button title="Atualiar" loading={loading} onPress={handleResetPassword} />
      </Content>
    </Container>
  );
}

export default UpdateProfile;
